import { Skeleton } from '@vtex/shoreline'

import styles from './styles.module.css'

const PacingCardSkeleton = () => (
  <div className={styles.card}>
    <div className={styles.header}>
      <Skeleton width="80px" height="14px" />
      <Skeleton width="76px" height="24px" />
    </div>
    <div className={styles.body}>
      <div className={styles.valueRow}>
        <Skeleton width="120px" height="34px" />
        <Skeleton width="40px" height="20px" />
      </div>
      <Skeleton width="100%" height="6px" />
    </div>
  </div>
)

export default PacingCardSkeleton
